export default {
  root: {
    '& th': {
      fontSize: '12px',
      fontWeight: 'bold',
      letterSpacing: '0.5px',
      color: '#888a91',
      textTransform: 'uppercase',
      padding: '30px'
    }
  }
};
